import request from '@utils/request';
import { withServerCache } from '@utils/serverCache';

const PREFIX = '[SETTINGS]';

export const CHANGE_LANGUAGE = `${PREFIX} SET_USER_LANGUAGE`;

export const changeLanguage = (language) => ({
  type: CHANGE_LANGUAGE,
  payload: language,
});

export const setUserLanguage = (lang) => (dispatch) => {
  dispatch(changeLanguage(lang));
};

export const GET_SETTINGS_REQUEST = `${PREFIX} GET_SETTINGS_REQUEST`;
export const GET_SETTINGS_SUCCESS = `${PREFIX} GET_SETTINGS_SUCCESS`;
export const GET_SETTINGS_FAILURE = `${PREFIX} GET_SETTINGS_FAILURE`;

export const getSettingsRequest = () => ({
  type: GET_SETTINGS_REQUEST,
});

export const getSettingsSuccess = (payload) => ({
  type: GET_SETTINGS_SUCCESS,
  payload,
});

export const getSettingsFailure = () => ({
  type: GET_SETTINGS_FAILURE,
});

export const getSettings = () => (dispatch) => {
  dispatch(getSettingsRequest());
  return withServerCache('settings', () => request.get('settings').then(({ data }) => data)).then(
    (data) => dispatch(getSettingsSuccess(data)),
    (error) => {
      dispatch(getSettingsFailure(error));

      throw error;
    }
  );
};

export const GET_SPA_SETTINGS_REQUEST = `${PREFIX} GET SPA SETTINGS REQUEST`;
export const GET_SPA_SETTINGS_SUCCESS = `${PREFIX} GET SPA SETTINGS SUCCESS`;
export const GET_SPA_SETTINGS_FAILURE = `${PREFIX} GET SPA SETTINGS FAILURE`;

export const fetchSpaSettingsRequest = () => ({
  type: GET_SPA_SETTINGS_REQUEST,
});

export const fetchSpaSettingsSuccess = (payload) => ({
  type: GET_SPA_SETTINGS_SUCCESS,
  payload,
});

export const fetchSpaSettingsFailure = () => ({
  type: GET_SPA_SETTINGS_FAILURE,
});

export const fetchSpaSettings = (propertyId) => (dispatch) => {
  dispatch(fetchSpaSettingsRequest());
  return request.get(`${propertyId}/spa-settings`).then(
    ({ data }) => dispatch(fetchSpaSettingsSuccess(data)),
    (error) => {
      dispatch(fetchSpaSettingsFailure(error));

      throw error;
    }
  );
};
